import { CounterExampleComponent } from './counter-example/counter-example.component';
import { CLPBPAppComponent } from './clpbp-app.component';
import { SessionTimeoutWarningComponent
} from './ld-angular-components/components/session-timeout-warning/session-timeout-warning.component';

export const declarations = [
  CounterExampleComponent,
  CLPBPAppComponent,
  SessionTimeoutWarningComponent
];
